import { IEpDevPEntityIdObject } from "./EpDevPEntityIdsServiceTypes";

export enum EpDevPAsyncApiFormat {
  JSON = "application/json",
  YAML = "application/x-yaml", 
  ZIP = "application/zip",
}
export enum EpDevPAsyncApiVersion {
  VERSION_2_2_0 = "2.2.0",
  VERSION_2_5_0 = "2.5.0"
}

export type TEpDevPZipElement = {
  fileName: string;
  content: Buffer;
}
export type TEpDevPAsyncApiZip = {
  asyncApiJson: TEpDevPZipElement;
  asyncApiYaml: TEpDevPZipElement;
  schemas: Array<TEpDevPZipElement>;
}

export interface IEpDevPApiParameter extends IEpDevPEntityIdObject {
  values: Array<string>;
}
